document.querySelectorAll('.facets--title-main').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.collection-wrapper').classList.toggle('active');
    document.querySelector('.facets-block-wrapper--vertical').classList.toggle('active'); 
     document.querySelector('.content-for-layout').classList.toggle('active-toggle-w'); 
     
  });
});
document.querySelectorAll('.size_chart-button').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.size_main, .size_wrapper').classList.toggle('active');
  });
});
document.querySelectorAll('.icon_close').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.size_main, .size_wrapper').classList.remove('active');
  });
});


$(document).on('click', '.tab-btn', function () {
  const tabId = $(this).attr('data-tab');
  const parent = $(this).closest('.tabs');
  const mainParent = $(this).closest('#MainContent');
  parent.find('.tab-btn').removeClass('active');
  parent.find('.tab-content').removeClass('active');
  mainParent.find('.style_switch.tab-content').removeClass('active');
  console.log(tabId,'tabId>>>>',`#${tabId}`);
  $(this).addClass('active');
  $(`#${tabId}`).addClass('active');
 mainParent.find(`[data-sid="${tabId}"]`).addClass('active');
});

$('.text-scroll-slider .group-block-content').slick({
  dots: false,
  arrows:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    fade: true
});


$('.slide_show-3-item').slick({
  dots: false,
  infinite: false,
  arrows:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    }
  ]
  });
$(document).on('click','.btn_click',function() {
    $('.estimate_product-wrap').css('display', 'flex');
});
$(document).on('click','.icon_close',function() {
    $('.estimate_product-wrap').hide();
});


$(document).on('click', 'details', function() {
    if (window.innerWidth <= 768) {
        $('.shopify-section-group-footer-group details').removeAttr('open');
        $('.pro-faq-section details').removeAttr('open');
    }
});


  if ($(window).width() >= 750) {
      var $items = $('.js-deskhotspot-slider .custom-product-hotspoot-wrapp');
      for (var i = 0; i < $items.length; i += 3) {
        $items.slice(i, i + 3).wrapAll('<div class="group-hotspot-product"></div>');
      }
   
  }

function initSliders() {
  const width = window.innerWidth;

  const $mobile = $('.js-hotspot-slider');
  const $desktop = $('.js-deskhotspot-slider');

  if (width < 1024) {
    if (!$mobile.hasClass('slick-initialized')) {
      $mobile.slick({
        mobileFirst: true,
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  } else if ($mobile.hasClass('slick-initialized')) {
    $mobile.slick('unslick');
  }

  if (width >= 750) {
    if (!$desktop.hasClass('slick-initialized')) {
      $desktop.slick({
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  } else if ($desktop.hasClass('slick-initialized')) {
    $desktop.slick('unslick');
  }
}


$(window).on('load resize', initSliders);

  document.addEventListener('shopify:section:load', function () {
    initSliders();
      
  });

  document.addEventListener('shopify:section:select', function () {
      initSliders();
  });

  document.addEventListener('shopify:block:select', function () {
      initSliders();
  });


$(window).on('scroll', function () {
  $('body').toggleClass(
    'header-scrolled',
    $(window).scrollTop() > ($('#header-component').outerHeight())
  );
});

/*
 * Publishes --bottom-bar-height so the floating widgets (WhatsApp bubble,
 * product video tile) can sit above whatever app-rendered bar is pinned to the
 * bottom of the viewport - currently Vitals' Sticky Add to Cart Bar, which is
 * mobile-only and was overlapping the WhatsApp button.
 *
 * Measured rather than hardcoded: the bar's height moves with its own settings
 * (variant picker, quantity row), with a title that wraps, and with the iOS
 * safe-area inset. base.css consumes the variable; when no bar is present it
 * stays 0px and the widgets keep their original offsets.
 */
(function trackBottomBarHeight() {
  var OWN_WIDGETS = '.whatsapp-float-wrapp, .floating-whatsapp, .fv-trigger, .video-popup';
  // Shopify's theme preview bar is staff-only - ignore it so previews match production.
  var IGNORED = '#PBarNextFrameWrapper';
  var queued = false;

  // Does this element actually paint something, or is it an invisible wrapper?
  function paints(styles) {
    if (styles.backgroundImage && styles.backgroundImage !== 'none') return true;
    var match = /rgba?\(([^)]+)\)/.exec(styles.backgroundColor || '');
    if (!match) return false;
    var parts = match[1].split(',');
    return parts.length < 4 || parseFloat(parts[3]) > 0.05;
  }

  function nearestFixed(el) {
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      if (window.getComputedStyle(node).position === 'fixed') return node;
    }
    return null;
  }

  /*
   * Asks what is painted in the corner the WhatsApp bubble sits in, and lifts the
   * widgets only if that turns out to be a bar pinned to the bottom.
   *
   * Two earlier approaches were wrong. Scanning for fixed elements by geometry
   * counted the 132px of body padding Vitals reserves from page load, so the
   * widgets floated high on a page showing no bar. Hit-testing alone still
   * matched the app's container, which is hit-testable well before the bar
   * animates in - it is simply transparent until then. So the first *painted*
   * thing at that point decides: page content means no bar, a fixed bar means
   * lift by its on-screen height.
   *
   * Sampled 4px off the bottom edge, below anything we position ourselves, so
   * our own widgets can never trigger it.
   */
  function measure() {
    var x = Math.max(0, window.innerWidth - 43);
    var y = window.innerHeight - 4;
    var stack = document.elementsFromPoint(x, y) || [];
    var tallest = 0;

    // The stack is not reliably topmost-first, so every entry gets examined
    // rather than letting the first painted one decide.
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el.closest(OWN_WIDGETS) || el.closest(IGNORED)) continue;

      var styles = window.getComputedStyle(el);
      if (parseFloat(styles.opacity) < 0.05) continue;
      if (!paints(styles)) continue;

      var bar = nearestFixed(el);
      if (!bar) continue; // ordinary page content painting there - not a bar

      var rect = bar.getBoundingClientRect();
      // Ignore hairlines and full-screen overlays (drawers, modals, login iframes).
      if (rect.height < 20 || rect.height > 220) continue;
      if (rect.width < window.innerWidth * 0.7) continue;

      // Height on screen, so a bar mid-slide lifts them only as far as it has come.
      // Keep the tallest match: a bar painted by a child still measures its own box.
      tallest = Math.max(tallest, Math.round(Math.max(0, window.innerHeight - rect.top)));
    }

    return tallest;
  }

  function publish() {
    queued = false;
    document.body.style.setProperty('--bottom-bar-height', measure() + 'px');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(publish);
  }

  document.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  // App bars mount late and animate themselves in and out.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

  publish();
})();

/*
 * Gate the app sticky add-to-cart bar (Vitals, #bundle-sticky_add_to_cart) on
 * the product's own Add to cart button: shown only once the shopper has
 * scrolled past it; hidden while it is on screen or still below the fold. The app's own "when to show" trigger fires on
 * the first scroll event regardless of where the button is, which on desktop
 * looks like the bar is there from the start. base.css hides the bar while
 * body carries .theme-atc-visible; layout/theme.liquid puts that class on the
 * body of every product template so it holds from first paint - this script
 * loads late, and setting it here left a flash before it ran.
 */
(function gateStickyBarOnAtcButton() {
  var button = document.querySelector('product-form-component .add-to-cart-button, .add-to-cart-button');
  // No button to watch (or no observer support): never leave the bar hidden.
  if (!button || !('IntersectionObserver' in window)) {
    document.body.classList.remove('theme-atc-visible');
    return;
  }

  // Phones (Oct 2026): the button sits ~1300px down, so wait only for a short
  // scroll (150px) instead; back near the top the bar hides again.
  if (window.matchMedia('(max-width: 768px)').matches) {
    var onScroll = function () {
      document.body.classList.toggle('theme-atc-visible', window.scrollY < 150);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return;
  }

  // Desktop: "passed" means the button has gone out above the viewport. Below the fold
  // (not reached yet) keeps the bar hidden too - on desktop the button sits
  // under the fold at load, and showing the bar then reads as "from the start".
  new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    var passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    document.body.classList.toggle('theme-atc-visible', !passed);
  }, { threshold: 0 }).observe(button);
})();

/**
 * Collection category icons (Figma desktop PLP): the tile that links to the collection being
 * viewed gets .is-current, which base.css shows as pink SemiBold. Tiles link via their own <a>.
 */
(function markCurrentCategoryTile() {
  var here = location.pathname.replace(/\/$/, '');
  document.querySelectorAll('.collection-cate-row .group-block').forEach(function (tile) {
    var link = tile.querySelector('a[href]') || (tile.closest('a[href]'));
    if (!link) return;
    var path = new URL(link.getAttribute('href'), location.origin).pathname.replace(/\/$/, '');
    tile.classList.toggle('is-current', path === here);
  });
})();

/**
 * PDP benefit chips under the rating (.pdp-chips group): an endless sideways loop. The set is
 * repeated before and after the real chips (copies are aria-hidden), and while scrolling the
 * position jumps back or forward by exactly one set, so after "Timeless design" the first chip
 * comes round again in both directions. Re-applies if a variant change re-renders the row.
 */
(function loopPdpChips() {
  function setup(track) {
    if (track.dataset.chipLoop === 'on') return;
    var chips = Array.prototype.filter.call(track.children, function (el) { return !el.hasAttribute('data-chip-copy'); });
    if (chips.length < 2) return;
    track.dataset.chipLoop = 'on';
    function copySet() {
      return chips.map(function (chip) {
        var copy = chip.cloneNode(true);
        copy.setAttribute('data-chip-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('id');
        return copy;
      });
    }
    copySet().reverse().forEach(function (copy) { track.insertBefore(copy, track.firstChild); });
    copySet().forEach(function (copy) { track.appendChild(copy); });

    function setWidth() { return chips[0].offsetLeft - track.firstElementChild.offsetLeft; }
    track.scrollLeft = setWidth();
    track.addEventListener('scroll', function () {
      var w = setWidth();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft > w * 1.5) track.scrollLeft -= w;
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.pdp-chips > .group-block-content').forEach(function (track) {
      if (track.dataset.chipLoop === 'on' && !track.querySelector('[data-chip-copy]')) delete track.dataset.chipLoop;
      setup(track);
    });
  }

  init();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
})();

/**
 * PDP floating video (snippets/product-floating-video.liquid) on phones: the tile stays compact
 * (.fv-compact, styled in base.css) and the first tap opens the full-screen player through the
 * snippet's own click handler (10 Oct 2026: the in-between "grow to normal size" tap was removed).
 */
(function compactFloatingVideo() {
  var wrap = document.getElementById('fvWrappeer');
  if (!wrap || !window.matchMedia('(max-width: 768px)').matches) return;
  wrap.classList.add('fv-compact');
})();
